import { Shareholder } from '../../types/api.types';

/** Static shareholders: 50 each for Apple 037833100, Tesla 88160R101, NVIDIA 67066G104; 5 each for Invesco QQQ Trust 46090E103 and iShares Core S&P 500 ETF 00214Q104. Copy-paste friendly. */
export const INITIAL_SHAREHOLDERS: Shareholder[] = [
    {
        id: 'josh-0001-4c1b-8a1a-46090e1030001',
        cusip: '46090E103',
        accountNumber: '460900100',
        email: 'josh@govotr.com',
        firstName: 'Josh',
        lastName: 'Rosenbloom',
        fullName: 'Josh Rosenbloom',
        numberOfShares: 2500,
        totalShares: 2500,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLQQQ100',
        addressLine1: '350 Fifth Avenue',
        addressLine2: 'Suite 4100',
        city: 'New York',
        state: 'NY',
        zipCode: '10118',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '46090E103', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'qqq-0001-4c1b-8a1a-46090e1030001',
        cusip: '46090E103',
        accountNumber: '460900000',
        email: 'olivia.bennett1@yopmail.com',
        firstName: 'Olivia',
        lastName: 'Bennett',
        fullName: 'Olivia Bennett',
        numberOfShares: 1000,
        totalShares: 1000,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLQQQ001',
        addressLine1: '4821 Maple Street',
        addressLine2: null,
        city: 'Chicago',
        state: 'IL',
        zipCode: '60614',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '46090E103', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'qqq-0002-4c1b-8a1a-46090e1030002',
        cusip: '46090E103',
        accountNumber: '460900001',
        email: 'ethan.carter2@yopmail.com',
        firstName: 'Ethan',
        lastName: 'Carter',
        fullName: 'Ethan Carter',
        numberOfShares: 1250,
        totalShares: 1250,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLQQQ002',
        addressLine1: '910 Lakeshore Drive',
        addressLine2: 'Apt 5B',
        city: 'Seattle',
        state: 'WA',
        zipCode: '98101',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '46090E103', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'qqq-0003-4c1b-8a1a-46090e1030003',
        cusip: '46090E103',
        accountNumber: '460900002',
        email: 'sophia.reyes3@yopmail.com',
        firstName: 'Sophia',
        lastName: 'Reyes',
        fullName: 'Sophia Reyes',
        numberOfShares: 1500,
        totalShares: 1500,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLQQQ003',
        addressLine1: '2200 Birch Avenue',
        addressLine2: null,
        city: 'Austin',
        state: 'TX',
        zipCode: '78701',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '46090E103', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'qqq-0004-4c1b-8a1a-46090e1030004',
        cusip: '46090E103',
        accountNumber: '460900003',
        email: 'liam.patel4@yopmail.com',
        firstName: 'Liam',
        lastName: 'Patel',
        fullName: 'Liam Patel',
        numberOfShares: 1750,
        totalShares: 1750,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLQQQ004',
        addressLine1: '77 Harbor Road',
        addressLine2: 'Unit 12',
        city: 'Boston',
        state: 'MA',
        zipCode: '02110',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '46090E103', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'qqq-0005-4c1b-8a1a-46090e1030005',
        cusip: '46090E103',
        accountNumber: '460900004',
        email: 'ava.nguyen5@yopmail.com',
        firstName: 'Ava',
        lastName: 'Nguyen',
        fullName: 'Ava Nguyen',
        numberOfShares: 2000,
        totalShares: 2000,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLQQQ005',
        addressLine1: '3315 Sunset Boulevard',
        addressLine2: null,
        city: 'Los Angeles',
        state: 'CA',
        zipCode: '90028',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '46090E103', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'ivv-0001-4c1b-8a1a-00214q1040001',
        cusip: '00214Q104',
        accountNumber: '002110000',
        email: 'noah.murphy1@yopmail.com',
        firstName: 'Noah',
        lastName: 'Murphy',
        fullName: 'Noah Murphy',
        numberOfShares: 2000,
        totalShares: 2000,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLIVV001',
        addressLine1: '1502 Pine Court',
        addressLine2: null,
        city: 'Denver',
        state: 'CO',
        zipCode: '80202',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '00214Q104', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'ivv-0002-4c1b-8a1a-00214q1040002',
        cusip: '00214Q104',
        accountNumber: '002110001',
        email: 'isabella.kim2@yopmail.com',
        firstName: 'Isabella',
        lastName: 'Kim',
        fullName: 'Isabella Kim',
        numberOfShares: 2250,
        totalShares: 2250,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLIVV002',
        addressLine1: '640 Riverside Way',
        addressLine2: 'Suite 300',
        city: 'Portland',
        state: 'OR',
        zipCode: '97204',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '00214Q104', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'ivv-0003-4c1b-8a1a-00214q1040003',
        cusip: '00214Q104',
        accountNumber: '002110002',
        email: 'mason.thompson3@yopmail.com',
        firstName: 'Mason',
        lastName: 'Thompson',
        fullName: 'Mason Thompson',
        numberOfShares: 2500,
        totalShares: 2500,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLIVV003',
        addressLine1: '89 Elm Terrace',
        addressLine2: null,
        city: 'Miami',
        state: 'FL',
        zipCode: '33131',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '00214Q104', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'ivv-0004-4c1b-8a1a-00214q1040004',
        cusip: '00214Q104',
        accountNumber: '002110003',
        email: 'mia.garcia4@yopmail.com',
        firstName: 'Mia',
        lastName: 'Garcia',
        fullName: 'Mia Garcia',
        numberOfShares: 2750,
        totalShares: 2750,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLIVV004',
        addressLine1: '4100 Cedar Lane',
        addressLine2: 'Apt 22',
        city: 'Phoenix',
        state: 'AZ',
        zipCode: '85004',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '00214Q104', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: 'ivv-0005-4c1b-8a1a-00214q1040005',
        cusip: '00214Q104',
        accountNumber: '002110004',
        email: 'lucas.anderson5@yopmail.com',
        firstName: 'Lucas',
        lastName: 'Anderson',
        fullName: 'Lucas Anderson',
        numberOfShares: 3000,
        totalShares: 3000,
        recordDate: '2026-09-01T10:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRLIVV005',
        addressLine1: '215 Willow Street',
        addressLine2: null,
        city: 'Atlanta',
        state: 'GA',
        zipCode: '30303',
        country: 'USA',
        createdAt: '2026-09-01T10:00:00.000Z',
        updatedAt: '2026-09-01T10:00:00.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '00214Q104', description: '', createdAt: '2026-09-09T00:00:00.000Z', updatedAt: '2026-09-09T00:00:00.000Z' },
    },
    {
        id: '6aee3c1d-6aee3c1c-4aee3c1b-8aee3c1a-6aee3c196aee3c18',
        cusip: '037833100',
        accountNumber: '177510000',
        email: 'james.wilson0@yopmail.com',
        firstName: 'James',
        lastName: 'Wilson',
        fullName: 'James Wilson',
        numberOfShares: 500,
        totalShares: 500,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '1245 Oak Boulevard',
        addressLine2: 'Suite 200',
        city: 'New York',
        state: 'NY',
        zipCode: '10001',
        country: 'USA',
        createdAt: '2025-07-31T17:01:02.000Z',
        updatedAt: '2025-07-31T18:01:02.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c1c-6aee3c1b-4aee3c1a-8aee3c19-6aee3c186aee3c17',
        cusip: '037833100',
        accountNumber: '177510001',
        email: 'mary.johnson1@yopmail.com',
        firstName: 'Mary',
        lastName: 'Johnson',
        fullName: 'Mary Johnson',
        numberOfShares: 627,
        totalShares: 627,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '892 Maple Drive',
        addressLine2: null,
        city: 'Los Angeles',
        state: 'CA',
        zipCode: '90001',
        country: 'USA',
        createdAt: '2025-07-31T17:01:03.000Z',
        updatedAt: '2025-07-31T18:01:03.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c1b-6aee3c1a-4aee3c19-8aee3c18-6aee3c176aee3c16',
        cusip: '037833100',
        accountNumber: '177510002',
        email: 'robert.davis2@yopmail.com',
        firstName: 'Robert',
        lastName: 'Davis',
        fullName: 'Robert Davis',
        numberOfShares: 754,
        totalShares: 754,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '3400 Peachtree Road NE',
        addressLine2: 'Apt 4B',
        city: 'Atlanta',
        state: 'GA',
        zipCode: '30326',
        country: 'USA',
        createdAt: '2025-07-31T17:01:04.000Z',
        updatedAt: '2025-07-31T18:01:04.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c1a-6aee3c19-4aee3c18-8aee3c17-6aee3c166aee3c15',
        cusip: '037833100',
        accountNumber: '177510003',
        email: 'patricia.martinez3@yopmail.com',
        firstName: 'Patricia',
        lastName: 'Martinez',
        fullName: 'Patricia Martinez',
        numberOfShares: 881,
        totalShares: 881,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '1567 Elm Street',
        addressLine2: null,
        city: 'Houston',
        state: 'TX',
        zipCode: '77001',
        country: 'USA',
        createdAt: '2025-07-31T17:01:05.000Z',
        updatedAt: '2025-07-31T18:01:05.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c19-6aee3c18-4aee3c17-8aee3c16-6aee3c156aee3c14',
        cusip: '037833100',
        accountNumber: '177510004',
        email: 'john.anderson4@yopmail.com',
        firstName: 'John',
        lastName: 'Anderson',
        fullName: 'John Anderson',
        numberOfShares: 1008,
        totalShares: 1008,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '2200 Michigan Avenue',
        addressLine2: null,
        city: 'Chicago',
        state: 'IL',
        zipCode: '60601',
        country: 'USA',
        createdAt: '2025-07-31T17:01:06.000Z',
        updatedAt: '2025-07-31T18:01:06.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c18-6aee3c17-4aee3c16-8aee3c15-6aee3c146aee3c13',
        cusip: '037833100',
        accountNumber: '177510005',
        email: 'jennifer.thomas5@yopmail.com',
        firstName: 'Jennifer',
        lastName: 'Thomas',
        fullName: 'Jennifer Thomas',
        numberOfShares: 1135,
        totalShares: 1135,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '901 Pine Lane',
        addressLine2: 'Unit 12',
        city: 'Phoenix',
        state: 'AZ',
        zipCode: '85001',
        country: 'USA',
        createdAt: '2025-07-31T17:01:07.000Z',
        updatedAt: '2025-07-31T18:01:07.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c17-6aee3c16-4aee3c15-8aee3c14-6aee3c136aee3c12',
        cusip: '037833100',
        accountNumber: '177510006',
        email: 'michael.jackson6@yopmail.com',
        firstName: 'Michael',
        lastName: 'Jackson',
        fullName: 'Michael Jackson',
        numberOfShares: 1262,
        totalShares: 1262,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '4455 Cedar Court',
        addressLine2: null,
        city: 'Philadelphia',
        state: 'PA',
        zipCode: '19101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:08.000Z',
        updatedAt: '2025-07-31T18:01:08.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c16-6aee3c15-4aee3c14-8aee3c13-6aee3c126aee3c11',
        cusip: '037833100',
        accountNumber: '177510007',
        email: 'linda.white7@yopmail.com',
        firstName: 'Linda',
        lastName: 'White',
        fullName: 'Linda White',
        numberOfShares: 1389,
        totalShares: 1389,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '678 Birch Avenue',
        addressLine2: null,
        city: 'San Antonio',
        state: 'TX',
        zipCode: '78201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:09.000Z',
        updatedAt: '2025-07-31T18:01:09.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c15-6aee3c14-4aee3c13-8aee3c12-6aee3c116aee3c10',
        cusip: '037833100',
        accountNumber: '177510008',
        email: 'david.harris8@yopmail.com',
        firstName: 'David',
        lastName: 'Harris',
        fullName: 'David Harris',
        numberOfShares: 1516,
        totalShares: 1516,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '3210 Walnut Street',
        addressLine2: 'Floor 3',
        city: 'San Diego',
        state: 'CA',
        zipCode: '92101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:10.000Z',
        updatedAt: '2025-07-31T18:01:10.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '6aee3c14-6aee3c13-4aee3c12-8aee3c11-6aee3c106aee3c0f',
        cusip: '037833100',
        accountNumber: '177510009',
        email: 'barbara.clark9@yopmail.com',
        firstName: 'Barbara',
        lastName: 'Clark',
        fullName: 'Barbara Clark',
        numberOfShares: 1643,
        totalShares: 1643,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '554 Spruce Way',
        addressLine2: null,
        city: 'Dallas',
        state: 'TX',
        zipCode: '75201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:11.000Z',
        updatedAt: '2025-07-31T18:01:11.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8cc-0d26b8cd-4d26b8ce-8d26b8cf-0d26b8d00d26b8d1',
        cusip: '037833100',
        accountNumber: '177510010',
        email: 'william.lewis10@yopmail.com',
        firstName: 'William',
        lastName: 'Lewis',
        fullName: 'William Lewis',
        numberOfShares: 1770,
        totalShares: 1770,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '789 Ash Boulevard',
        addressLine2: null,
        city: 'San Jose',
        state: 'CA',
        zipCode: '95101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:12.000Z',
        updatedAt: '2025-07-31T18:01:12.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8cd-0d26b8ce-4d26b8cf-8d26b8d0-0d26b8d10d26b8d2',
        cusip: '037833100',
        accountNumber: '177510011',
        email: 'elizabeth.robinson11@yopmail.com',
        firstName: 'Elizabeth',
        lastName: 'Robinson',
        fullName: 'Elizabeth Robinson',
        numberOfShares: 1897,
        totalShares: 1897,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '2100 Park Avenue',
        addressLine2: 'Apt 7C',
        city: 'Austin',
        state: 'TX',
        zipCode: '78701',
        country: 'USA',
        createdAt: '2025-07-31T17:01:13.000Z',
        updatedAt: '2025-07-31T18:01:13.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8ce-0d26b8cf-4d26b8d0-8d26b8d1-0d26b8d20d26b8d3',
        cusip: '037833100',
        accountNumber: '177510012',
        email: 'richard.walker12@yopmail.com',
        firstName: 'Richard',
        lastName: 'Walker',
        fullName: 'Richard Walker',
        numberOfShares: 2024,
        totalShares: 2024,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '1200 Commerce Street',
        addressLine2: null,
        city: 'Jacksonville',
        state: 'FL',
        zipCode: '32099',
        country: 'USA',
        createdAt: '2025-07-31T17:01:14.000Z',
        updatedAt: '2025-07-31T18:01:14.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8cf-0d26b8d0-4d26b8d1-8d26b8d2-0d26b8d30d26b8d4',
        cusip: '037833100',
        accountNumber: '177510013',
        email: 'susan.young13@yopmail.com',
        firstName: 'Susan',
        lastName: 'Young',
        fullName: 'Susan Young',
        numberOfShares: 2151,
        totalShares: 2151,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '456 Hickory Lane',
        addressLine2: null,
        city: 'Fort Worth',
        state: 'TX',
        zipCode: '76101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:15.000Z',
        updatedAt: '2025-07-31T18:01:15.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8d0-0d26b8d1-4d26b8d2-8d26b8d3-0d26b8d40d26b8d5',
        cusip: '037833100',
        accountNumber: '177510014',
        email: 'joseph.king14@yopmail.com',
        firstName: 'Joseph',
        lastName: 'King',
        fullName: 'Joseph King',
        numberOfShares: 2278,
        totalShares: 2278,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '3333 Vine Street',
        addressLine2: null,
        city: 'Columbus',
        state: 'OH',
        zipCode: '43201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:16.000Z',
        updatedAt: '2025-07-31T18:01:16.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8d1-0d26b8d2-4d26b8d3-8d26b8d4-0d26b8d50d26b8d6',
        cusip: '037833100',
        accountNumber: '177510015',
        email: 'jessica.wright15@yopmail.com',
        firstName: 'Jessica',
        lastName: 'Wright',
        fullName: 'Jessica Wright',
        numberOfShares: 2405,
        totalShares: 2405,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '987 Laurel Drive',
        addressLine2: 'Suite 100',
        city: 'Charlotte',
        state: 'NC',
        zipCode: '28201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:17.000Z',
        updatedAt: '2025-07-31T18:01:17.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8d2-0d26b8d3-4d26b8d4-8d26b8d5-0d26b8d60d26b8d7',
        cusip: '037833100',
        accountNumber: '177510016',
        email: 'charles.lopez16@yopmail.com',
        firstName: 'Charles',
        lastName: 'Lopez',
        fullName: 'Charles Lopez',
        numberOfShares: 2532,
        totalShares: 2532,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '555 Oak Hill Road',
        addressLine2: null,
        city: 'Indianapolis',
        state: 'IN',
        zipCode: '46201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:18.000Z',
        updatedAt: '2025-07-31T18:01:18.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8d3-0d26b8d4-4d26b8d5-8d26b8d6-0d26b8d70d26b8d8',
        cusip: '037833100',
        accountNumber: '177510017',
        email: 'sarah.hill17@yopmail.com',
        firstName: 'Sarah',
        lastName: 'Hill',
        fullName: 'Sarah Hill',
        numberOfShares: 2659,
        totalShares: 2659,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '777 Sunset Boulevard',
        addressLine2: null,
        city: 'Seattle',
        state: 'WA',
        zipCode: '98101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:19.000Z',
        updatedAt: '2025-07-31T18:01:19.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8d4-0d26b8d5-4d26b8d6-8d26b8d7-0d26b8d80d26b8d9',
        cusip: '037833100',
        accountNumber: '177510018',
        email: 'thomas.scott18@yopmail.com',
        firstName: 'Thomas',
        lastName: 'Scott',
        fullName: 'Thomas Scott',
        numberOfShares: 2786,
        totalShares: 2786,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '888 River Road',
        addressLine2: null,
        city: 'Denver',
        state: 'CO',
        zipCode: '80201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:20.000Z',
        updatedAt: '2025-07-31T18:01:20.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8d5-0d26b8d6-4d26b8d7-8d26b8d8-0d26b8d90d26b8da',
        cusip: '037833100',
        accountNumber: '177510019',
        email: 'karen.green19@yopmail.com',
        firstName: 'Karen',
        lastName: 'Green',
        fullName: 'Karen Green',
        numberOfShares: 2913,
        totalShares: 2913,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '999 Meadow Lane',
        addressLine2: 'Apt 2A',
        city: 'Boston',
        state: 'MA',
        zipCode: '02101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:21.000Z',
        updatedAt: '2025-07-31T18:01:21.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8eb-0d26b8ec-4d26b8ed-8d26b8ee-0d26b8ef0d26b8f0',
        cusip: '037833100',
        accountNumber: '177510020',
        email: 'christopher.adams20@yopmail.com',
        firstName: 'Christopher',
        lastName: 'Adams',
        fullName: 'Christopher Adams',
        numberOfShares: 3040,
        totalShares: 3040,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '111 Forest Avenue',
        addressLine2: null,
        city: 'Nashville',
        state: 'TN',
        zipCode: '37201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:22.000Z',
        updatedAt: '2025-07-31T18:01:22.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8ec-0d26b8ed-4d26b8ee-8d26b8ef-0d26b8f00d26b8f1',
        cusip: '037833100',
        accountNumber: '177510021',
        email: 'nancy.baker21@yopmail.com',
        firstName: 'Nancy',
        lastName: 'Baker',
        fullName: 'Nancy Baker',
        numberOfShares: 3167,
        totalShares: 3167,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '222 Lake View Drive',
        addressLine2: null,
        city: 'Detroit',
        state: 'MI',
        zipCode: '48201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:23.000Z',
        updatedAt: '2025-07-31T18:01:23.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8ed-0d26b8ee-4d26b8ef-8d26b8f0-0d26b8f10d26b8f2',
        cusip: '037833100',
        accountNumber: '177510022',
        email: 'daniel.gonzalez22@yopmail.com',
        firstName: 'Daniel',
        lastName: 'Gonzalez',
        fullName: 'Daniel Gonzalez',
        numberOfShares: 3294,
        totalShares: 3294,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '333 Hillcrest Way',
        addressLine2: null,
        city: 'Portland',
        state: 'OR',
        zipCode: '97201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:24.000Z',
        updatedAt: '2025-07-31T18:01:24.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8ee-0d26b8ef-4d26b8f0-8d26b8f1-0d26b8f20d26b8f3',
        cusip: '037833100',
        accountNumber: '177510023',
        email: 'betty.nelson23@yopmail.com',
        firstName: 'Betty',
        lastName: 'Nelson',
        fullName: 'Betty Nelson',
        numberOfShares: 3421,
        totalShares: 3421,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '444 Valley Road',
        addressLine2: null,
        city: 'Las Vegas',
        state: 'NV',
        zipCode: '89101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:25.000Z',
        updatedAt: '2025-07-31T18:01:25.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8ef-0d26b8f0-4d26b8f1-8d26b8f2-0d26b8f30d26b8f4',
        cusip: '037833100',
        accountNumber: '177510024',
        email: 'matthew.carter24@yopmail.com',
        firstName: 'Matthew',
        lastName: 'Carter',
        fullName: 'Matthew Carter',
        numberOfShares: 3548,
        totalShares: 3548,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '555 Ridge Avenue',
        addressLine2: 'Unit 5',
        city: 'Baltimore',
        state: 'MD',
        zipCode: '21201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:26.000Z',
        updatedAt: '2025-07-31T18:01:26.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8f0-0d26b8f1-4d26b8f2-8d26b8f3-0d26b8f40d26b8f5',
        cusip: '037833100',
        accountNumber: '177510025',
        email: 'margaret.mitchell25@yopmail.com',
        firstName: 'Margaret',
        lastName: 'Mitchell',
        fullName: 'Margaret Mitchell',
        numberOfShares: 3675,
        totalShares: 3675,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '666 Highland Drive',
        addressLine2: null,
        city: 'Milwaukee',
        state: 'WI',
        zipCode: '53201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:27.000Z',
        updatedAt: '2025-07-31T18:01:27.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8f1-0d26b8f2-4d26b8f3-8d26b8f4-0d26b8f50d26b8f6',
        cusip: '037833100',
        accountNumber: '177510026',
        email: 'anthony.perez26@yopmail.com',
        firstName: 'Anthony',
        lastName: 'Perez',
        fullName: 'Anthony Perez',
        numberOfShares: 3802,
        totalShares: 3802,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '777 Brook Street',
        addressLine2: null,
        city: 'Albuquerque',
        state: 'NM',
        zipCode: '87101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:28.000Z',
        updatedAt: '2025-07-31T18:01:28.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8f2-0d26b8f3-4d26b8f4-8d26b8f5-0d26b8f60d26b8f7',
        cusip: '037833100',
        accountNumber: '177510027',
        email: 'sandra.roberts27@yopmail.com',
        firstName: 'Sandra',
        lastName: 'Roberts',
        fullName: 'Sandra Roberts',
        numberOfShares: 3929,
        totalShares: 3929,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '888 Canyon Road',
        addressLine2: null,
        city: 'Tucson',
        state: 'AZ',
        zipCode: '85701',
        country: 'USA',
        createdAt: '2025-07-31T17:01:29.000Z',
        updatedAt: '2025-07-31T18:01:29.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8f3-0d26b8f4-4d26b8f5-8d26b8f6-0d26b8f70d26b8f8',
        cusip: '037833100',
        accountNumber: '177510028',
        email: 'mark.turner28@yopmail.com',
        firstName: 'Mark',
        lastName: 'Turner',
        fullName: 'Mark Turner',
        numberOfShares: 4056,
        totalShares: 4056,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '999 Summit Avenue',
        addressLine2: null,
        city: 'Fresno',
        state: 'CA',
        zipCode: '93701',
        country: 'USA',
        createdAt: '2025-07-31T17:01:30.000Z',
        updatedAt: '2025-07-31T18:01:30.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b8f4-0d26b8f5-4d26b8f6-8d26b8f7-0d26b8f80d26b8f9',
        cusip: '037833100',
        accountNumber: '177510029',
        email: 'ashley.phillips29@yopmail.com',
        firstName: 'Ashley',
        lastName: 'Phillips',
        fullName: 'Ashley Phillips',
        numberOfShares: 4183,
        totalShares: 4183,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '1000 Plaza Drive',
        addressLine2: 'Suite 300',
        city: 'Sacramento',
        state: 'CA',
        zipCode: '95814',
        country: 'USA',
        createdAt: '2025-07-31T17:01:31.000Z',
        updatedAt: '2025-07-31T18:01:31.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b90a-0d26b90b-4d26b90c-8d26b90d-0d26b90e0d26b90f',
        cusip: '037833100',
        accountNumber: '177510030',
        email: 'donald.campbell30@yopmail.com',
        firstName: 'Donald',
        lastName: 'Campbell',
        fullName: 'Donald Campbell',
        numberOfShares: 4310,
        totalShares: 4310,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '1100 Gateway Blvd',
        addressLine2: null,
        city: 'Kansas City',
        state: 'MO',
        zipCode: '64101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:32.000Z',
        updatedAt: '2025-07-31T18:01:32.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b90b-0d26b90c-4d26b90d-8d26b90e-0d26b90f0d26b910',
        cusip: '037833100',
        accountNumber: '177510031',
        email: 'kimberly.parker31@yopmail.com',
        firstName: 'Kimberly',
        lastName: 'Parker',
        fullName: 'Kimberly Parker',
        numberOfShares: 4437,
        totalShares: 4437,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '1212 Central Avenue',
        addressLine2: null,
        city: 'Mesa',
        state: 'AZ',
        zipCode: '85201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:33.000Z',
        updatedAt: '2025-07-31T18:01:33.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b90c-0d26b90d-4d26b90e-8d26b90f-0d26b9100d26b911',
        cusip: '037833100',
        accountNumber: '177510032',
        email: 'steven.evans32@yopmail.com',
        firstName: 'Steven',
        lastName: 'Evans',
        fullName: 'Steven Evans',
        numberOfShares: 4564,
        totalShares: 4564,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '1313 North Main Street',
        addressLine2: null,
        city: 'Virginia Beach',
        state: 'VA',
        zipCode: '23451',
        country: 'USA',
        createdAt: '2025-07-31T17:01:34.000Z',
        updatedAt: '2025-07-31T18:01:34.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b90d-0d26b90e-4d26b90f-8d26b910-0d26b9110d26b912',
        cusip: '037833100',
        accountNumber: '177510033',
        email: 'donna.edwards33@yopmail.com',
        firstName: 'Donna',
        lastName: 'Edwards',
        fullName: 'Donna Edwards',
        numberOfShares: 4691,
        totalShares: 4691,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '1414 South Park Road',
        addressLine2: null,
        city: 'Omaha',
        state: 'NE',
        zipCode: '68101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:35.000Z',
        updatedAt: '2025-07-31T18:01:35.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b90e-0d26b90f-4d26b910-8d26b911-0d26b9120d26b913',
        cusip: '037833100',
        accountNumber: '177510034',
        email: 'paul.collins34@yopmail.com',
        firstName: 'Paul',
        lastName: 'Collins',
        fullName: 'Paul Collins',
        numberOfShares: 4818,
        totalShares: 4818,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '1515 East Broadway',
        addressLine2: 'Apt 9',
        city: 'Oakland',
        state: 'CA',
        zipCode: '94601',
        country: 'USA',
        createdAt: '2025-07-31T17:01:36.000Z',
        updatedAt: '2025-07-31T18:01:36.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b90f-0d26b910-4d26b911-8d26b912-0d26b9130d26b914',
        cusip: '037833100',
        accountNumber: '177510035',
        email: 'emily.stewart35@yopmail.com',
        firstName: 'Emily',
        lastName: 'Stewart',
        fullName: 'Emily Stewart',
        numberOfShares: 4945,
        totalShares: 4945,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '1616 West End Avenue',
        addressLine2: null,
        city: 'Miami',
        state: 'FL',
        zipCode: '33101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:37.000Z',
        updatedAt: '2025-07-31T18:01:37.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b910-0d26b911-4d26b912-8d26b913-0d26b9140d26b915',
        cusip: '037833100',
        accountNumber: '177510036',
        email: 'andrew.sanchez36@yopmail.com',
        firstName: 'Andrew',
        lastName: 'Sanchez',
        fullName: 'Andrew Sanchez',
        numberOfShares: 5072,
        totalShares: 5072,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '1717 Riverside Drive',
        addressLine2: null,
        city: 'Minneapolis',
        state: 'MN',
        zipCode: '55401',
        country: 'USA',
        createdAt: '2025-07-31T17:01:38.000Z',
        updatedAt: '2025-07-31T18:01:38.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b911-0d26b912-4d26b913-8d26b914-0d26b9150d26b916',
        cusip: '037833100',
        accountNumber: '177510037',
        email: 'michelle.morris37@yopmail.com',
        firstName: 'Michelle',
        lastName: 'Morris',
        fullName: 'Michelle Morris',
        numberOfShares: 5199,
        totalShares: 5199,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '1818 Mountain View Lane',
        addressLine2: null,
        city: 'Tulsa',
        state: 'OK',
        zipCode: '74101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:39.000Z',
        updatedAt: '2025-07-31T18:01:39.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b912-0d26b913-4d26b914-8d26b915-0d26b9160d26b917',
        cusip: '037833100',
        accountNumber: '177510038',
        email: 'joshua.rogers38@yopmail.com',
        firstName: 'Joshua',
        lastName: 'Rogers',
        fullName: 'Joshua Rogers',
        numberOfShares: 5326,
        totalShares: 5326,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '1919 Harbor Way',
        addressLine2: null,
        city: 'Cleveland',
        state: 'OH',
        zipCode: '44101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:40.000Z',
        updatedAt: '2025-07-31T18:01:40.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b913-0d26b914-4d26b915-8d26b916-0d26b9170d26b918',
        cusip: '037833100',
        accountNumber: '177510039',
        email: 'dorothy.reed39@yopmail.com',
        firstName: 'Dorothy',
        lastName: 'Reed',
        fullName: 'Dorothy Reed',
        numberOfShares: 5453,
        totalShares: 5453,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '2020 Bridge Street',
        addressLine2: null,
        city: 'Wichita',
        state: 'KS',
        zipCode: '67201',
        country: 'USA',
        createdAt: '2025-07-31T17:01:41.000Z',
        updatedAt: '2025-07-31T18:01:41.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b929-0d26b92a-4d26b92b-8d26b92c-0d26b92d0d26b92e',
        cusip: '037833100',
        accountNumber: '177510040',
        email: 'kenneth.cook40@yopmail.com',
        firstName: 'Kenneth',
        lastName: 'Cook',
        fullName: 'Kenneth Cook',
        numberOfShares: 580,
        totalShares: 580,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '2121 Harbor Drive',
        addressLine2: 'Unit 15',
        city: 'Arlington',
        state: 'TX',
        zipCode: '76001',
        country: 'USA',
        createdAt: '2025-07-31T17:01:42.000Z',
        updatedAt: '2025-07-31T18:01:42.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b92a-0d26b92b-4d26b92c-8d26b92d-0d26b92e0d26b92f',
        cusip: '037833100',
        accountNumber: '177510041',
        email: 'carol.morgan41@yopmail.com',
        firstName: 'Carol',
        lastName: 'Morgan',
        fullName: 'Carol Morgan',
        numberOfShares: 707,
        totalShares: 707,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '2222 Bay Street',
        addressLine2: null,
        city: 'New Orleans',
        state: 'LA',
        zipCode: '70112',
        country: 'USA',
        createdAt: '2025-07-31T17:01:43.000Z',
        updatedAt: '2025-07-31T18:01:43.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b92b-0d26b92c-4d26b92d-8d26b92e-0d26b92f0d26b930',
        cusip: '037833100',
        accountNumber: '177510042',
        email: 'kevin.bell42@yopmail.com',
        firstName: 'Kevin',
        lastName: 'Bell',
        fullName: 'Kevin Bell',
        numberOfShares: 834,
        totalShares: 834,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '2323 Coast Highway',
        addressLine2: null,
        city: 'Tampa',
        state: 'FL',
        zipCode: '33601',
        country: 'USA',
        createdAt: '2025-07-31T17:01:44.000Z',
        updatedAt: '2025-07-31T18:01:44.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b92c-0d26b92d-4d26b92e-8d26b92f-0d26b9300d26b931',
        cusip: '037833100',
        accountNumber: '177510043',
        email: 'amanda.murphy43@yopmail.com',
        firstName: 'Amanda',
        lastName: 'Murphy',
        fullName: 'Amanda Murphy',
        numberOfShares: 961,
        totalShares: 961,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '2424 Island Avenue',
        addressLine2: null,
        city: 'Honolulu',
        state: 'HI',
        zipCode: '96801',
        country: 'USA',
        createdAt: '2025-07-31T17:01:45.000Z',
        updatedAt: '2025-07-31T18:01:45.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b92d-0d26b92e-4d26b92f-8d26b930-0d26b9310d26b932',
        cusip: '037833100',
        accountNumber: '177510044',
        email: 'brian.bailey44@yopmail.com',
        firstName: 'Brian',
        lastName: 'Bailey',
        fullName: 'Brian Bailey',
        numberOfShares: 1088,
        totalShares: 1088,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '2525 Prairie Road',
        addressLine2: null,
        city: 'Aurora',
        state: 'CO',
        zipCode: '80010',
        country: 'USA',
        createdAt: '2025-07-31T17:01:46.000Z',
        updatedAt: '2025-07-31T18:01:46.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b92e-0d26b92f-4d26b930-8d26b931-0d26b9320d26b933',
        cusip: '037833100',
        accountNumber: '177510045',
        email: 'melissa.rivera45@yopmail.com',
        firstName: 'Melissa',
        lastName: 'Rivera',
        fullName: 'Melissa Rivera',
        numberOfShares: 1215,
        totalShares: 1215,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '2626 Desert Lane',
        addressLine2: null,
        city: 'Anaheim',
        state: 'CA',
        zipCode: '92801',
        country: 'USA',
        createdAt: '2025-07-31T17:01:47.000Z',
        updatedAt: '2025-07-31T18:01:47.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b92f-0d26b930-4d26b931-8d26b932-0d26b9330d26b934',
        cusip: '037833100',
        accountNumber: '177510046',
        email: 'george.cooper46@yopmail.com',
        firstName: 'George',
        lastName: 'Cooper',
        fullName: 'George Cooper',
        numberOfShares: 1342,
        totalShares: 1342,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '2727 Garden Street',
        addressLine2: null,
        city: 'Santa Ana',
        state: 'CA',
        zipCode: '92701',
        country: 'USA',
        createdAt: '2025-07-31T17:01:48.000Z',
        updatedAt: '2025-07-31T18:01:48.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b930-0d26b931-4d26b932-8d26b933-0d26b9340d26b935',
        cusip: '037833100',
        accountNumber: '177510047',
        email: 'deborah.richardson47@yopmail.com',
        firstName: 'Deborah',
        lastName: 'Richardson',
        fullName: 'Deborah Richardson',
        numberOfShares: 1469,
        totalShares: 1469,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '2828 Vineyard Way',
        addressLine2: null,
        city: 'St. Louis',
        state: 'MO',
        zipCode: '63101',
        country: 'USA',
        createdAt: '2025-07-31T17:01:49.000Z',
        updatedAt: '2025-07-31T18:01:49.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b931-0d26b932-4d26b933-8d26b934-0d26b9350d26b936',
        cusip: '037833100',
        accountNumber: '177510048',
        email: 'edward.cox48@yopmail.com',
        firstName: 'Edward',
        lastName: 'Cox',
        fullName: 'Edward Cox',
        numberOfShares: 1596,
        totalShares: 1596,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '2929 Orchard Drive',
        addressLine2: null,
        city: 'Riverside',
        state: 'CA',
        zipCode: '92501',
        country: 'USA',
        createdAt: '2025-07-31T17:01:50.000Z',
        updatedAt: '2025-07-31T18:01:50.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '0d26b932-0d26b933-4d26b934-8d26b935-0d26b9360d26b937',
        cusip: '037833100',
        accountNumber: '177510049',
        email: 'stephanie.howard49@yopmail.com',
        firstName: 'Stephanie',
        lastName: 'Howard',
        fullName: 'Stephanie Howard',
        numberOfShares: 1723,
        totalShares: 1723,
        recordDate: '2025-07-31T17:01:01.750Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '3030 Meadowbrook Lane',
        addressLine2: null,
        city: 'Corpus Christi',
        state: 'TX',
        zipCode: '78401',
        country: 'USA',
        createdAt: '2025-07-31T17:01:51.000Z',
        updatedAt: '2025-07-31T18:01:51.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '037833100', description: '', createdAt: '2025-07-31T17:01:01.097Z', updatedAt: '2025-07-31T17:01:01.097Z' },
    },
    {
        id: '40364305-40364306-40364307-80364308-403643094036430a',
        cusip: '88160R101',
        accountNumber: '188610100',
        email: 'james.wilson0@yopmail.com',
        firstName: 'James',
        lastName: 'Wilson',
        fullName: 'James Wilson',
        numberOfShares: 500,
        totalShares: 500,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '1245 Oak Boulevard',
        addressLine2: 'Suite 200',
        city: 'New York',
        state: 'NY',
        zipCode: '10001',
        country: 'USA',
        createdAt: '2025-07-31T17:02:02.000Z',
        updatedAt: '2025-07-31T18:02:02.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '40364306-40364307-40364308-80364309-4036430a4036430b',
        cusip: '88160R101',
        accountNumber: '188610101',
        email: 'mary.johnson1@yopmail.com',
        firstName: 'Mary',
        lastName: 'Johnson',
        fullName: 'Mary Johnson',
        numberOfShares: 627,
        totalShares: 627,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '892 Maple Drive',
        addressLine2: null,
        city: 'Los Angeles',
        state: 'CA',
        zipCode: '90001',
        country: 'USA',
        createdAt: '2025-07-31T17:02:03.000Z',
        updatedAt: '2025-07-31T18:02:03.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '40364307-40364308-40364309-8036430a-4036430b4036430c',
        cusip: '88160R101',
        accountNumber: '188610102',
        email: 'robert.davis2@yopmail.com',
        firstName: 'Robert',
        lastName: 'Davis',
        fullName: 'Robert Davis',
        numberOfShares: 754,
        totalShares: 754,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '3400 Peachtree Road NE',
        addressLine2: 'Apt 4B',
        city: 'Atlanta',
        state: 'GA',
        zipCode: '30326',
        country: 'USA',
        createdAt: '2025-07-31T17:02:04.000Z',
        updatedAt: '2025-07-31T18:02:04.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '40364308-40364309-4036430a-8036430b-4036430c4036430d',
        cusip: '88160R101',
        accountNumber: '188610103',
        email: 'patricia.martinez3@yopmail.com',
        firstName: 'Patricia',
        lastName: 'Martinez',
        fullName: 'Patricia Martinez',
        numberOfShares: 881,
        totalShares: 881,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '1567 Elm Street',
        addressLine2: null,
        city: 'Houston',
        state: 'TX',
        zipCode: '77001',
        country: 'USA',
        createdAt: '2025-07-31T17:02:05.000Z',
        updatedAt: '2025-07-31T18:02:05.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '40364309-4036430a-4036430b-8036430c-4036430d4036430e',
        cusip: '88160R101',
        accountNumber: '188610104',
        email: 'john.anderson4@yopmail.com',
        firstName: 'John',
        lastName: 'Anderson',
        fullName: 'John Anderson',
        numberOfShares: 1008,
        totalShares: 1008,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '2200 Michigan Avenue',
        addressLine2: null,
        city: 'Chicago',
        state: 'IL',
        zipCode: '60601',
        country: 'USA',
        createdAt: '2025-07-31T17:02:06.000Z',
        updatedAt: '2025-07-31T18:02:06.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '4036430a-4036430b-4036430c-8036430d-4036430e4036430f',
        cusip: '88160R101',
        accountNumber: '188610105',
        email: 'jennifer.thomas5@yopmail.com',
        firstName: 'Jennifer',
        lastName: 'Thomas',
        fullName: 'Jennifer Thomas',
        numberOfShares: 1135,
        totalShares: 1135,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '901 Pine Lane',
        addressLine2: 'Unit 12',
        city: 'Phoenix',
        state: 'AZ',
        zipCode: '85001',
        country: 'USA',
        createdAt: '2025-07-31T17:02:07.000Z',
        updatedAt: '2025-07-31T18:02:07.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '4036430b-4036430c-4036430d-8036430e-4036430f40364310',
        cusip: '88160R101',
        accountNumber: '188610106',
        email: 'michael.jackson6@yopmail.com',
        firstName: 'Michael',
        lastName: 'Jackson',
        fullName: 'Michael Jackson',
        numberOfShares: 1262,
        totalShares: 1262,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '4455 Cedar Court',
        addressLine2: null,
        city: 'Philadelphia',
        state: 'PA',
        zipCode: '19101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:08.000Z',
        updatedAt: '2025-07-31T18:02:08.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '4036430c-4036430d-4036430e-8036430f-4036431040364311',
        cusip: '88160R101',
        accountNumber: '188610107',
        email: 'linda.white7@yopmail.com',
        firstName: 'Linda',
        lastName: 'White',
        fullName: 'Linda White',
        numberOfShares: 1389,
        totalShares: 1389,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '678 Birch Avenue',
        addressLine2: null,
        city: 'San Antonio',
        state: 'TX',
        zipCode: '78201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:09.000Z',
        updatedAt: '2025-07-31T18:02:09.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '4036430d-4036430e-4036430f-80364310-4036431140364312',
        cusip: '88160R101',
        accountNumber: '188610108',
        email: 'david.harris8@yopmail.com',
        firstName: 'David',
        lastName: 'Harris',
        fullName: 'David Harris',
        numberOfShares: 1516,
        totalShares: 1516,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '3210 Walnut Street',
        addressLine2: 'Floor 3',
        city: 'San Diego',
        state: 'CA',
        zipCode: '92101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:10.000Z',
        updatedAt: '2025-07-31T18:02:10.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '4036430e-4036430f-40364310-80364311-4036431240364313',
        cusip: '88160R101',
        accountNumber: '188610109',
        email: 'barbara.clark9@yopmail.com',
        firstName: 'Barbara',
        lastName: 'Clark',
        fullName: 'Barbara Clark',
        numberOfShares: 1643,
        totalShares: 1643,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '554 Spruce Way',
        addressLine2: null,
        city: 'Dallas',
        state: 'TX',
        zipCode: '75201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:11.000Z',
        updatedAt: '2025-07-31T18:02:11.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de216-396de215-496de214-896de213-396de212396de211',
        cusip: '88160R101',
        accountNumber: '188610110',
        email: 'william.lewis10@yopmail.com',
        firstName: 'William',
        lastName: 'Lewis',
        fullName: 'William Lewis',
        numberOfShares: 1770,
        totalShares: 1770,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '789 Ash Boulevard',
        addressLine2: null,
        city: 'San Jose',
        state: 'CA',
        zipCode: '95101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:12.000Z',
        updatedAt: '2025-07-31T18:02:12.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de215-396de214-496de213-896de212-396de211396de210',
        cusip: '88160R101',
        accountNumber: '188610111',
        email: 'elizabeth.robinson11@yopmail.com',
        firstName: 'Elizabeth',
        lastName: 'Robinson',
        fullName: 'Elizabeth Robinson',
        numberOfShares: 1897,
        totalShares: 1897,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '2100 Park Avenue',
        addressLine2: 'Apt 7C',
        city: 'Austin',
        state: 'TX',
        zipCode: '78701',
        country: 'USA',
        createdAt: '2025-07-31T17:02:13.000Z',
        updatedAt: '2025-07-31T18:02:13.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de214-396de213-496de212-896de211-396de210396de20f',
        cusip: '88160R101',
        accountNumber: '188610112',
        email: 'richard.walker12@yopmail.com',
        firstName: 'Richard',
        lastName: 'Walker',
        fullName: 'Richard Walker',
        numberOfShares: 2024,
        totalShares: 2024,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '1200 Commerce Street',
        addressLine2: null,
        city: 'Jacksonville',
        state: 'FL',
        zipCode: '32099',
        country: 'USA',
        createdAt: '2025-07-31T17:02:14.000Z',
        updatedAt: '2025-07-31T18:02:14.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de213-396de212-496de211-896de210-396de20f396de20e',
        cusip: '88160R101',
        accountNumber: '188610113',
        email: 'susan.young13@yopmail.com',
        firstName: 'Susan',
        lastName: 'Young',
        fullName: 'Susan Young',
        numberOfShares: 2151,
        totalShares: 2151,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '456 Hickory Lane',
        addressLine2: null,
        city: 'Fort Worth',
        state: 'TX',
        zipCode: '76101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:15.000Z',
        updatedAt: '2025-07-31T18:02:15.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de212-396de211-496de210-896de20f-396de20e396de20d',
        cusip: '88160R101',
        accountNumber: '188610114',
        email: 'joseph.king14@yopmail.com',
        firstName: 'Joseph',
        lastName: 'King',
        fullName: 'Joseph King',
        numberOfShares: 2278,
        totalShares: 2278,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '3333 Vine Street',
        addressLine2: null,
        city: 'Columbus',
        state: 'OH',
        zipCode: '43201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:16.000Z',
        updatedAt: '2025-07-31T18:02:16.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de211-396de210-496de20f-896de20e-396de20d396de20c',
        cusip: '88160R101',
        accountNumber: '188610115',
        email: 'jessica.wright15@yopmail.com',
        firstName: 'Jessica',
        lastName: 'Wright',
        fullName: 'Jessica Wright',
        numberOfShares: 2405,
        totalShares: 2405,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '987 Laurel Drive',
        addressLine2: 'Suite 100',
        city: 'Charlotte',
        state: 'NC',
        zipCode: '28201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:17.000Z',
        updatedAt: '2025-07-31T18:02:17.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de210-396de20f-496de20e-896de20d-396de20c396de20b',
        cusip: '88160R101',
        accountNumber: '188610116',
        email: 'charles.lopez16@yopmail.com',
        firstName: 'Charles',
        lastName: 'Lopez',
        fullName: 'Charles Lopez',
        numberOfShares: 2532,
        totalShares: 2532,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '555 Oak Hill Road',
        addressLine2: null,
        city: 'Indianapolis',
        state: 'IN',
        zipCode: '46201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:18.000Z',
        updatedAt: '2025-07-31T18:02:18.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de20f-396de20e-496de20d-896de20c-396de20b396de20a',
        cusip: '88160R101',
        accountNumber: '188610117',
        email: 'sarah.hill17@yopmail.com',
        firstName: 'Sarah',
        lastName: 'Hill',
        fullName: 'Sarah Hill',
        numberOfShares: 2659,
        totalShares: 2659,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '777 Sunset Boulevard',
        addressLine2: null,
        city: 'Seattle',
        state: 'WA',
        zipCode: '98101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:19.000Z',
        updatedAt: '2025-07-31T18:02:19.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de20e-396de20d-496de20c-896de20b-396de20a396de209',
        cusip: '88160R101',
        accountNumber: '188610118',
        email: 'thomas.scott18@yopmail.com',
        firstName: 'Thomas',
        lastName: 'Scott',
        fullName: 'Thomas Scott',
        numberOfShares: 2786,
        totalShares: 2786,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '888 River Road',
        addressLine2: null,
        city: 'Denver',
        state: 'CO',
        zipCode: '80201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:20.000Z',
        updatedAt: '2025-07-31T18:02:20.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de20d-396de20c-496de20b-896de20a-396de209396de208',
        cusip: '88160R101',
        accountNumber: '188610119',
        email: 'karen.green19@yopmail.com',
        firstName: 'Karen',
        lastName: 'Green',
        fullName: 'Karen Green',
        numberOfShares: 2913,
        totalShares: 2913,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '999 Meadow Lane',
        addressLine2: 'Apt 2A',
        city: 'Boston',
        state: 'MA',
        zipCode: '02101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:21.000Z',
        updatedAt: '2025-07-31T18:02:21.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f7-396de1f6-496de1f5-896de1f4-396de1f3396de1f2',
        cusip: '88160R101',
        accountNumber: '188610120',
        email: 'christopher.adams20@yopmail.com',
        firstName: 'Christopher',
        lastName: 'Adams',
        fullName: 'Christopher Adams',
        numberOfShares: 3040,
        totalShares: 3040,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '111 Forest Avenue',
        addressLine2: null,
        city: 'Nashville',
        state: 'TN',
        zipCode: '37201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:22.000Z',
        updatedAt: '2025-07-31T18:02:22.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f6-396de1f5-496de1f4-896de1f3-396de1f2396de1f1',
        cusip: '88160R101',
        accountNumber: '188610121',
        email: 'nancy.baker21@yopmail.com',
        firstName: 'Nancy',
        lastName: 'Baker',
        fullName: 'Nancy Baker',
        numberOfShares: 3167,
        totalShares: 3167,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '222 Lake View Drive',
        addressLine2: null,
        city: 'Detroit',
        state: 'MI',
        zipCode: '48201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:23.000Z',
        updatedAt: '2025-07-31T18:02:23.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f5-396de1f4-496de1f3-896de1f2-396de1f1396de1f0',
        cusip: '88160R101',
        accountNumber: '188610122',
        email: 'daniel.gonzalez22@yopmail.com',
        firstName: 'Daniel',
        lastName: 'Gonzalez',
        fullName: 'Daniel Gonzalez',
        numberOfShares: 3294,
        totalShares: 3294,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '333 Hillcrest Way',
        addressLine2: null,
        city: 'Portland',
        state: 'OR',
        zipCode: '97201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:24.000Z',
        updatedAt: '2025-07-31T18:02:24.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f4-396de1f3-496de1f2-896de1f1-396de1f0396de1ef',
        cusip: '88160R101',
        accountNumber: '188610123',
        email: 'betty.nelson23@yopmail.com',
        firstName: 'Betty',
        lastName: 'Nelson',
        fullName: 'Betty Nelson',
        numberOfShares: 3421,
        totalShares: 3421,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '444 Valley Road',
        addressLine2: null,
        city: 'Las Vegas',
        state: 'NV',
        zipCode: '89101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:25.000Z',
        updatedAt: '2025-07-31T18:02:25.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f3-396de1f2-496de1f1-896de1f0-396de1ef396de1ee',
        cusip: '88160R101',
        accountNumber: '188610124',
        email: 'matthew.carter24@yopmail.com',
        firstName: 'Matthew',
        lastName: 'Carter',
        fullName: 'Matthew Carter',
        numberOfShares: 3548,
        totalShares: 3548,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '555 Ridge Avenue',
        addressLine2: 'Unit 5',
        city: 'Baltimore',
        state: 'MD',
        zipCode: '21201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:26.000Z',
        updatedAt: '2025-07-31T18:02:26.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f2-396de1f1-496de1f0-896de1ef-396de1ee396de1ed',
        cusip: '88160R101',
        accountNumber: '188610125',
        email: 'margaret.mitchell25@yopmail.com',
        firstName: 'Margaret',
        lastName: 'Mitchell',
        fullName: 'Margaret Mitchell',
        numberOfShares: 3675,
        totalShares: 3675,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '666 Highland Drive',
        addressLine2: null,
        city: 'Milwaukee',
        state: 'WI',
        zipCode: '53201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:27.000Z',
        updatedAt: '2025-07-31T18:02:27.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f1-396de1f0-496de1ef-896de1ee-396de1ed396de1ec',
        cusip: '88160R101',
        accountNumber: '188610126',
        email: 'anthony.perez26@yopmail.com',
        firstName: 'Anthony',
        lastName: 'Perez',
        fullName: 'Anthony Perez',
        numberOfShares: 3802,
        totalShares: 3802,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '777 Brook Street',
        addressLine2: null,
        city: 'Albuquerque',
        state: 'NM',
        zipCode: '87101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:28.000Z',
        updatedAt: '2025-07-31T18:02:28.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1f0-396de1ef-496de1ee-896de1ed-396de1ec396de1eb',
        cusip: '88160R101',
        accountNumber: '188610127',
        email: 'sandra.roberts27@yopmail.com',
        firstName: 'Sandra',
        lastName: 'Roberts',
        fullName: 'Sandra Roberts',
        numberOfShares: 3929,
        totalShares: 3929,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '888 Canyon Road',
        addressLine2: null,
        city: 'Tucson',
        state: 'AZ',
        zipCode: '85701',
        country: 'USA',
        createdAt: '2025-07-31T17:02:29.000Z',
        updatedAt: '2025-07-31T18:02:29.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1ef-396de1ee-496de1ed-896de1ec-396de1eb396de1ea',
        cusip: '88160R101',
        accountNumber: '188610128',
        email: 'mark.turner28@yopmail.com',
        firstName: 'Mark',
        lastName: 'Turner',
        fullName: 'Mark Turner',
        numberOfShares: 4056,
        totalShares: 4056,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '999 Summit Avenue',
        addressLine2: null,
        city: 'Fresno',
        state: 'CA',
        zipCode: '93701',
        country: 'USA',
        createdAt: '2025-07-31T17:02:30.000Z',
        updatedAt: '2025-07-31T18:02:30.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1ee-396de1ed-496de1ec-896de1eb-396de1ea396de1e9',
        cusip: '88160R101',
        accountNumber: '188610129',
        email: 'ashley.phillips29@yopmail.com',
        firstName: 'Ashley',
        lastName: 'Phillips',
        fullName: 'Ashley Phillips',
        numberOfShares: 4183,
        totalShares: 4183,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '1000 Plaza Drive',
        addressLine2: 'Suite 300',
        city: 'Sacramento',
        state: 'CA',
        zipCode: '95814',
        country: 'USA',
        createdAt: '2025-07-31T17:02:31.000Z',
        updatedAt: '2025-07-31T18:02:31.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d8-396de1d7-496de1d6-896de1d5-396de1d4396de1d3',
        cusip: '88160R101',
        accountNumber: '188610130',
        email: 'donald.campbell30@yopmail.com',
        firstName: 'Donald',
        lastName: 'Campbell',
        fullName: 'Donald Campbell',
        numberOfShares: 4310,
        totalShares: 4310,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '1100 Gateway Blvd',
        addressLine2: null,
        city: 'Kansas City',
        state: 'MO',
        zipCode: '64101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:32.000Z',
        updatedAt: '2025-07-31T18:02:32.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d7-396de1d6-496de1d5-896de1d4-396de1d3396de1d2',
        cusip: '88160R101',
        accountNumber: '188610131',
        email: 'kimberly.parker31@yopmail.com',
        firstName: 'Kimberly',
        lastName: 'Parker',
        fullName: 'Kimberly Parker',
        numberOfShares: 4437,
        totalShares: 4437,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '1212 Central Avenue',
        addressLine2: null,
        city: 'Mesa',
        state: 'AZ',
        zipCode: '85201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:33.000Z',
        updatedAt: '2025-07-31T18:02:33.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d6-396de1d5-496de1d4-896de1d3-396de1d2396de1d1',
        cusip: '88160R101',
        accountNumber: '188610132',
        email: 'steven.evans32@yopmail.com',
        firstName: 'Steven',
        lastName: 'Evans',
        fullName: 'Steven Evans',
        numberOfShares: 4564,
        totalShares: 4564,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '1313 North Main Street',
        addressLine2: null,
        city: 'Virginia Beach',
        state: 'VA',
        zipCode: '23451',
        country: 'USA',
        createdAt: '2025-07-31T17:02:34.000Z',
        updatedAt: '2025-07-31T18:02:34.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d5-396de1d4-496de1d3-896de1d2-396de1d1396de1d0',
        cusip: '88160R101',
        accountNumber: '188610133',
        email: 'donna.edwards33@yopmail.com',
        firstName: 'Donna',
        lastName: 'Edwards',
        fullName: 'Donna Edwards',
        numberOfShares: 4691,
        totalShares: 4691,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '1414 South Park Road',
        addressLine2: null,
        city: 'Omaha',
        state: 'NE',
        zipCode: '68101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:35.000Z',
        updatedAt: '2025-07-31T18:02:35.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d4-396de1d3-496de1d2-896de1d1-396de1d0396de1cf',
        cusip: '88160R101',
        accountNumber: '188610134',
        email: 'paul.collins34@yopmail.com',
        firstName: 'Paul',
        lastName: 'Collins',
        fullName: 'Paul Collins',
        numberOfShares: 4818,
        totalShares: 4818,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '1515 East Broadway',
        addressLine2: 'Apt 9',
        city: 'Oakland',
        state: 'CA',
        zipCode: '94601',
        country: 'USA',
        createdAt: '2025-07-31T17:02:36.000Z',
        updatedAt: '2025-07-31T18:02:36.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d3-396de1d2-496de1d1-896de1d0-396de1cf396de1ce',
        cusip: '88160R101',
        accountNumber: '188610135',
        email: 'emily.stewart35@yopmail.com',
        firstName: 'Emily',
        lastName: 'Stewart',
        fullName: 'Emily Stewart',
        numberOfShares: 4945,
        totalShares: 4945,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '1616 West End Avenue',
        addressLine2: null,
        city: 'Miami',
        state: 'FL',
        zipCode: '33101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:37.000Z',
        updatedAt: '2025-07-31T18:02:37.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d2-396de1d1-496de1d0-896de1cf-396de1ce396de1cd',
        cusip: '88160R101',
        accountNumber: '188610136',
        email: 'andrew.sanchez36@yopmail.com',
        firstName: 'Andrew',
        lastName: 'Sanchez',
        fullName: 'Andrew Sanchez',
        numberOfShares: 5072,
        totalShares: 5072,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '1717 Riverside Drive',
        addressLine2: null,
        city: 'Minneapolis',
        state: 'MN',
        zipCode: '55401',
        country: 'USA',
        createdAt: '2025-07-31T17:02:38.000Z',
        updatedAt: '2025-07-31T18:02:38.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d1-396de1d0-496de1cf-896de1ce-396de1cd396de1cc',
        cusip: '88160R101',
        accountNumber: '188610137',
        email: 'michelle.morris37@yopmail.com',
        firstName: 'Michelle',
        lastName: 'Morris',
        fullName: 'Michelle Morris',
        numberOfShares: 5199,
        totalShares: 5199,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '1818 Mountain View Lane',
        addressLine2: null,
        city: 'Tulsa',
        state: 'OK',
        zipCode: '74101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:39.000Z',
        updatedAt: '2025-07-31T18:02:39.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1d0-396de1cf-496de1ce-896de1cd-396de1cc396de1cb',
        cusip: '88160R101',
        accountNumber: '188610138',
        email: 'joshua.rogers38@yopmail.com',
        firstName: 'Joshua',
        lastName: 'Rogers',
        fullName: 'Joshua Rogers',
        numberOfShares: 5326,
        totalShares: 5326,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '1919 Harbor Way',
        addressLine2: null,
        city: 'Cleveland',
        state: 'OH',
        zipCode: '44101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:40.000Z',
        updatedAt: '2025-07-31T18:02:40.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1cf-396de1ce-496de1cd-896de1cc-396de1cb396de1ca',
        cusip: '88160R101',
        accountNumber: '188610139',
        email: 'dorothy.reed39@yopmail.com',
        firstName: 'Dorothy',
        lastName: 'Reed',
        fullName: 'Dorothy Reed',
        numberOfShares: 5453,
        totalShares: 5453,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '2020 Bridge Street',
        addressLine2: null,
        city: 'Wichita',
        state: 'KS',
        zipCode: '67201',
        country: 'USA',
        createdAt: '2025-07-31T17:02:41.000Z',
        updatedAt: '2025-07-31T18:02:41.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b9-396de1b8-496de1b7-896de1b6-396de1b5396de1b4',
        cusip: '88160R101',
        accountNumber: '188610140',
        email: 'kenneth.cook40@yopmail.com',
        firstName: 'Kenneth',
        lastName: 'Cook',
        fullName: 'Kenneth Cook',
        numberOfShares: 580,
        totalShares: 580,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '2121 Harbor Drive',
        addressLine2: 'Unit 15',
        city: 'Arlington',
        state: 'TX',
        zipCode: '76001',
        country: 'USA',
        createdAt: '2025-07-31T17:02:42.000Z',
        updatedAt: '2025-07-31T18:02:42.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b8-396de1b7-496de1b6-896de1b5-396de1b4396de1b3',
        cusip: '88160R101',
        accountNumber: '188610141',
        email: 'carol.morgan41@yopmail.com',
        firstName: 'Carol',
        lastName: 'Morgan',
        fullName: 'Carol Morgan',
        numberOfShares: 707,
        totalShares: 707,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '2222 Bay Street',
        addressLine2: null,
        city: 'New Orleans',
        state: 'LA',
        zipCode: '70112',
        country: 'USA',
        createdAt: '2025-07-31T17:02:43.000Z',
        updatedAt: '2025-07-31T18:02:43.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b7-396de1b6-496de1b5-896de1b4-396de1b3396de1b2',
        cusip: '88160R101',
        accountNumber: '188610142',
        email: 'kevin.bell42@yopmail.com',
        firstName: 'Kevin',
        lastName: 'Bell',
        fullName: 'Kevin Bell',
        numberOfShares: 834,
        totalShares: 834,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '2323 Coast Highway',
        addressLine2: null,
        city: 'Tampa',
        state: 'FL',
        zipCode: '33601',
        country: 'USA',
        createdAt: '2025-07-31T17:02:44.000Z',
        updatedAt: '2025-07-31T18:02:44.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b6-396de1b5-496de1b4-896de1b3-396de1b2396de1b1',
        cusip: '88160R101',
        accountNumber: '188610143',
        email: 'amanda.murphy43@yopmail.com',
        firstName: 'Amanda',
        lastName: 'Murphy',
        fullName: 'Amanda Murphy',
        numberOfShares: 961,
        totalShares: 961,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '2424 Island Avenue',
        addressLine2: null,
        city: 'Honolulu',
        state: 'HI',
        zipCode: '96801',
        country: 'USA',
        createdAt: '2025-07-31T17:02:45.000Z',
        updatedAt: '2025-07-31T18:02:45.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b5-396de1b4-496de1b3-896de1b2-396de1b1396de1b0',
        cusip: '88160R101',
        accountNumber: '188610144',
        email: 'brian.bailey44@yopmail.com',
        firstName: 'Brian',
        lastName: 'Bailey',
        fullName: 'Brian Bailey',
        numberOfShares: 1088,
        totalShares: 1088,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '2525 Prairie Road',
        addressLine2: null,
        city: 'Aurora',
        state: 'CO',
        zipCode: '80010',
        country: 'USA',
        createdAt: '2025-07-31T17:02:46.000Z',
        updatedAt: '2025-07-31T18:02:46.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b4-396de1b3-496de1b2-896de1b1-396de1b0396de1af',
        cusip: '88160R101',
        accountNumber: '188610145',
        email: 'melissa.rivera45@yopmail.com',
        firstName: 'Melissa',
        lastName: 'Rivera',
        fullName: 'Melissa Rivera',
        numberOfShares: 1215,
        totalShares: 1215,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '2626 Desert Lane',
        addressLine2: null,
        city: 'Anaheim',
        state: 'CA',
        zipCode: '92801',
        country: 'USA',
        createdAt: '2025-07-31T17:02:47.000Z',
        updatedAt: '2025-07-31T18:02:47.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b3-396de1b2-496de1b1-896de1b0-396de1af396de1ae',
        cusip: '88160R101',
        accountNumber: '188610146',
        email: 'george.cooper46@yopmail.com',
        firstName: 'George',
        lastName: 'Cooper',
        fullName: 'George Cooper',
        numberOfShares: 1342,
        totalShares: 1342,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '2727 Garden Street',
        addressLine2: null,
        city: 'Santa Ana',
        state: 'CA',
        zipCode: '92701',
        country: 'USA',
        createdAt: '2025-07-31T17:02:48.000Z',
        updatedAt: '2025-07-31T18:02:48.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b2-396de1b1-496de1b0-896de1af-396de1ae396de1ad',
        cusip: '88160R101',
        accountNumber: '188610147',
        email: 'deborah.richardson47@yopmail.com',
        firstName: 'Deborah',
        lastName: 'Richardson',
        fullName: 'Deborah Richardson',
        numberOfShares: 1469,
        totalShares: 1469,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '2828 Vineyard Way',
        addressLine2: null,
        city: 'St. Louis',
        state: 'MO',
        zipCode: '63101',
        country: 'USA',
        createdAt: '2025-07-31T17:02:49.000Z',
        updatedAt: '2025-07-31T18:02:49.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b1-396de1b0-496de1af-896de1ae-396de1ad396de1ac',
        cusip: '88160R101',
        accountNumber: '188610148',
        email: 'edward.cox48@yopmail.com',
        firstName: 'Edward',
        lastName: 'Cox',
        fullName: 'Edward Cox',
        numberOfShares: 1596,
        totalShares: 1596,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '2929 Orchard Drive',
        addressLine2: null,
        city: 'Riverside',
        state: 'CA',
        zipCode: '92501',
        country: 'USA',
        createdAt: '2025-07-31T17:02:50.000Z',
        updatedAt: '2025-07-31T18:02:50.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '396de1b0-396de1af-496de1ae-896de1ad-396de1ac396de1ab',
        cusip: '88160R101',
        accountNumber: '188610149',
        email: 'stephanie.howard49@yopmail.com',
        firstName: 'Stephanie',
        lastName: 'Howard',
        fullName: 'Stephanie Howard',
        numberOfShares: 1723,
        totalShares: 1723,
        recordDate: '2025-08-01T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '3030 Meadowbrook Lane',
        addressLine2: null,
        city: 'Corpus Christi',
        state: 'TX',
        zipCode: '78401',
        country: 'USA',
        createdAt: '2025-07-31T17:02:51.000Z',
        updatedAt: '2025-07-31T18:02:51.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '88160R101', description: '', createdAt: '2025-08-01T13:43:49.131Z', updatedAt: '2025-08-01T13:43:49.131Z' },
    },
    {
        id: '651fd673-651fd674-451fd675-851fd676-651fd677651fd678',
        cusip: '67066G104',
        accountNumber: '670610200',
        email: 'james.wilson0@yopmail.com',
        firstName: 'James',
        lastName: 'Wilson',
        fullName: 'James Wilson',
        numberOfShares: 500,
        totalShares: 500,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '1245 Oak Boulevard',
        addressLine2: 'Suite 200',
        city: 'New York',
        state: 'NY',
        zipCode: '10001',
        country: 'USA',
        createdAt: '2025-07-31T17:03:02.000Z',
        updatedAt: '2025-07-31T18:03:02.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd674-651fd675-451fd676-851fd677-651fd678651fd679',
        cusip: '67066G104',
        accountNumber: '670610201',
        email: 'mary.johnson1@yopmail.com',
        firstName: 'Mary',
        lastName: 'Johnson',
        fullName: 'Mary Johnson',
        numberOfShares: 627,
        totalShares: 627,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '892 Maple Drive',
        addressLine2: null,
        city: 'Los Angeles',
        state: 'CA',
        zipCode: '90001',
        country: 'USA',
        createdAt: '2025-07-31T17:03:03.000Z',
        updatedAt: '2025-07-31T18:03:03.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd675-651fd676-451fd677-851fd678-651fd679651fd67a',
        cusip: '67066G104',
        accountNumber: '670610202',
        email: 'robert.davis2@yopmail.com',
        firstName: 'Robert',
        lastName: 'Davis',
        fullName: 'Robert Davis',
        numberOfShares: 754,
        totalShares: 754,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '3400 Peachtree Road NE',
        addressLine2: 'Apt 4B',
        city: 'Atlanta',
        state: 'GA',
        zipCode: '30326',
        country: 'USA',
        createdAt: '2025-07-31T17:03:04.000Z',
        updatedAt: '2025-07-31T18:03:04.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd676-651fd677-451fd678-851fd679-651fd67a651fd67b',
        cusip: '67066G104',
        accountNumber: '670610203',
        email: 'patricia.martinez3@yopmail.com',
        firstName: 'Patricia',
        lastName: 'Martinez',
        fullName: 'Patricia Martinez',
        numberOfShares: 881,
        totalShares: 881,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '1567 Elm Street',
        addressLine2: null,
        city: 'Houston',
        state: 'TX',
        zipCode: '77001',
        country: 'USA',
        createdAt: '2025-07-31T17:03:05.000Z',
        updatedAt: '2025-07-31T18:03:05.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd677-651fd678-451fd679-851fd67a-651fd67b651fd67c',
        cusip: '67066G104',
        accountNumber: '670610204',
        email: 'john.anderson4@yopmail.com',
        firstName: 'John',
        lastName: 'Anderson',
        fullName: 'John Anderson',
        numberOfShares: 1008,
        totalShares: 1008,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '2200 Michigan Avenue',
        addressLine2: null,
        city: 'Chicago',
        state: 'IL',
        zipCode: '60601',
        country: 'USA',
        createdAt: '2025-07-31T17:03:06.000Z',
        updatedAt: '2025-07-31T18:03:06.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd678-651fd679-451fd67a-851fd67b-651fd67c651fd67d',
        cusip: '67066G104',
        accountNumber: '670610205',
        email: 'jennifer.thomas5@yopmail.com',
        firstName: 'Jennifer',
        lastName: 'Thomas',
        fullName: 'Jennifer Thomas',
        numberOfShares: 1135,
        totalShares: 1135,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '901 Pine Lane',
        addressLine2: 'Unit 12',
        city: 'Phoenix',
        state: 'AZ',
        zipCode: '85001',
        country: 'USA',
        createdAt: '2025-07-31T17:03:07.000Z',
        updatedAt: '2025-07-31T18:03:07.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd679-651fd67a-451fd67b-851fd67c-651fd67d651fd67e',
        cusip: '67066G104',
        accountNumber: '670610206',
        email: 'michael.jackson6@yopmail.com',
        firstName: 'Michael',
        lastName: 'Jackson',
        fullName: 'Michael Jackson',
        numberOfShares: 1262,
        totalShares: 1262,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '4455 Cedar Court',
        addressLine2: null,
        city: 'Philadelphia',
        state: 'PA',
        zipCode: '19101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:08.000Z',
        updatedAt: '2025-07-31T18:03:08.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd67a-651fd67b-451fd67c-851fd67d-651fd67e651fd67f',
        cusip: '67066G104',
        accountNumber: '670610207',
        email: 'linda.white7@yopmail.com',
        firstName: 'Linda',
        lastName: 'White',
        fullName: 'Linda White',
        numberOfShares: 1389,
        totalShares: 1389,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '678 Birch Avenue',
        addressLine2: null,
        city: 'San Antonio',
        state: 'TX',
        zipCode: '78201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:09.000Z',
        updatedAt: '2025-07-31T18:03:09.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd67b-651fd67c-451fd67d-851fd67e-651fd67f651fd680',
        cusip: '67066G104',
        accountNumber: '670610208',
        email: 'david.harris8@yopmail.com',
        firstName: 'David',
        lastName: 'Harris',
        fullName: 'David Harris',
        numberOfShares: 1516,
        totalShares: 1516,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '3210 Walnut Street',
        addressLine2: 'Floor 3',
        city: 'San Diego',
        state: 'CA',
        zipCode: '92101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:10.000Z',
        updatedAt: '2025-07-31T18:03:10.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '651fd67c-651fd67d-451fd67e-851fd67f-651fd680651fd681',
        cusip: '67066G104',
        accountNumber: '670610209',
        email: 'barbara.clark9@yopmail.com',
        firstName: 'Barbara',
        lastName: 'Clark',
        fullName: 'Barbara Clark',
        numberOfShares: 1643,
        totalShares: 1643,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '554 Spruce Way',
        addressLine2: null,
        city: 'Dallas',
        state: 'TX',
        zipCode: '75201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:11.000Z',
        updatedAt: '2025-07-31T18:03:11.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf83c-3edaf83d-4edaf83e-8edaf83f-3edaf8403edaf841',
        cusip: '67066G104',
        accountNumber: '670610210',
        email: 'william.lewis10@yopmail.com',
        firstName: 'William',
        lastName: 'Lewis',
        fullName: 'William Lewis',
        numberOfShares: 1770,
        totalShares: 1770,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '789 Ash Boulevard',
        addressLine2: null,
        city: 'San Jose',
        state: 'CA',
        zipCode: '95101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:12.000Z',
        updatedAt: '2025-07-31T18:03:12.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf83d-3edaf83e-4edaf83f-8edaf840-3edaf8413edaf842',
        cusip: '67066G104',
        accountNumber: '670610211',
        email: 'elizabeth.robinson11@yopmail.com',
        firstName: 'Elizabeth',
        lastName: 'Robinson',
        fullName: 'Elizabeth Robinson',
        numberOfShares: 1897,
        totalShares: 1897,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '2100 Park Avenue',
        addressLine2: 'Apt 7C',
        city: 'Austin',
        state: 'TX',
        zipCode: '78701',
        country: 'USA',
        createdAt: '2025-07-31T17:03:13.000Z',
        updatedAt: '2025-07-31T18:03:13.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf83e-3edaf83f-4edaf840-8edaf841-3edaf8423edaf843',
        cusip: '67066G104',
        accountNumber: '670610212',
        email: 'richard.walker12@yopmail.com',
        firstName: 'Richard',
        lastName: 'Walker',
        fullName: 'Richard Walker',
        numberOfShares: 2024,
        totalShares: 2024,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '1200 Commerce Street',
        addressLine2: null,
        city: 'Jacksonville',
        state: 'FL',
        zipCode: '32099',
        country: 'USA',
        createdAt: '2025-07-31T17:03:14.000Z',
        updatedAt: '2025-07-31T18:03:14.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf83f-3edaf840-4edaf841-8edaf842-3edaf8433edaf844',
        cusip: '67066G104',
        accountNumber: '670610213',
        email: 'susan.young13@yopmail.com',
        firstName: 'Susan',
        lastName: 'Young',
        fullName: 'Susan Young',
        numberOfShares: 2151,
        totalShares: 2151,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '456 Hickory Lane',
        addressLine2: null,
        city: 'Fort Worth',
        state: 'TX',
        zipCode: '76101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:15.000Z',
        updatedAt: '2025-07-31T18:03:15.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf840-3edaf841-4edaf842-8edaf843-3edaf8443edaf845',
        cusip: '67066G104',
        accountNumber: '670610214',
        email: 'joseph.king14@yopmail.com',
        firstName: 'Joseph',
        lastName: 'King',
        fullName: 'Joseph King',
        numberOfShares: 2278,
        totalShares: 2278,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '3333 Vine Street',
        addressLine2: null,
        city: 'Columbus',
        state: 'OH',
        zipCode: '43201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:16.000Z',
        updatedAt: '2025-07-31T18:03:16.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf841-3edaf842-4edaf843-8edaf844-3edaf8453edaf846',
        cusip: '67066G104',
        accountNumber: '670610215',
        email: 'jessica.wright15@yopmail.com',
        firstName: 'Jessica',
        lastName: 'Wright',
        fullName: 'Jessica Wright',
        numberOfShares: 2405,
        totalShares: 2405,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '987 Laurel Drive',
        addressLine2: 'Suite 100',
        city: 'Charlotte',
        state: 'NC',
        zipCode: '28201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:17.000Z',
        updatedAt: '2025-07-31T18:03:17.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf842-3edaf843-4edaf844-8edaf845-3edaf8463edaf847',
        cusip: '67066G104',
        accountNumber: '670610216',
        email: 'charles.lopez16@yopmail.com',
        firstName: 'Charles',
        lastName: 'Lopez',
        fullName: 'Charles Lopez',
        numberOfShares: 2532,
        totalShares: 2532,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '555 Oak Hill Road',
        addressLine2: null,
        city: 'Indianapolis',
        state: 'IN',
        zipCode: '46201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:18.000Z',
        updatedAt: '2025-07-31T18:03:18.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf843-3edaf844-4edaf845-8edaf846-3edaf8473edaf848',
        cusip: '67066G104',
        accountNumber: '670610217',
        email: 'sarah.hill17@yopmail.com',
        firstName: 'Sarah',
        lastName: 'Hill',
        fullName: 'Sarah Hill',
        numberOfShares: 2659,
        totalShares: 2659,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '777 Sunset Boulevard',
        addressLine2: null,
        city: 'Seattle',
        state: 'WA',
        zipCode: '98101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:19.000Z',
        updatedAt: '2025-07-31T18:03:19.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf844-3edaf845-4edaf846-8edaf847-3edaf8483edaf849',
        cusip: '67066G104',
        accountNumber: '670610218',
        email: 'thomas.scott18@yopmail.com',
        firstName: 'Thomas',
        lastName: 'Scott',
        fullName: 'Thomas Scott',
        numberOfShares: 2786,
        totalShares: 2786,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '888 River Road',
        addressLine2: null,
        city: 'Denver',
        state: 'CO',
        zipCode: '80201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:20.000Z',
        updatedAt: '2025-07-31T18:03:20.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf845-3edaf846-4edaf847-8edaf848-3edaf8493edaf84a',
        cusip: '67066G104',
        accountNumber: '670610219',
        email: 'karen.green19@yopmail.com',
        firstName: 'Karen',
        lastName: 'Green',
        fullName: 'Karen Green',
        numberOfShares: 2913,
        totalShares: 2913,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '999 Meadow Lane',
        addressLine2: 'Apt 2A',
        city: 'Boston',
        state: 'MA',
        zipCode: '02101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:21.000Z',
        updatedAt: '2025-07-31T18:03:21.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf85b-3edaf85c-4edaf85d-8edaf85e-3edaf85f3edaf860',
        cusip: '67066G104',
        accountNumber: '670610220',
        email: 'christopher.adams20@yopmail.com',
        firstName: 'Christopher',
        lastName: 'Adams',
        fullName: 'Christopher Adams',
        numberOfShares: 3040,
        totalShares: 3040,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '111 Forest Avenue',
        addressLine2: null,
        city: 'Nashville',
        state: 'TN',
        zipCode: '37201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:22.000Z',
        updatedAt: '2025-07-31T18:03:22.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf85c-3edaf85d-4edaf85e-8edaf85f-3edaf8603edaf861',
        cusip: '67066G104',
        accountNumber: '670610221',
        email: 'nancy.baker21@yopmail.com',
        firstName: 'Nancy',
        lastName: 'Baker',
        fullName: 'Nancy Baker',
        numberOfShares: 3167,
        totalShares: 3167,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '222 Lake View Drive',
        addressLine2: null,
        city: 'Detroit',
        state: 'MI',
        zipCode: '48201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:23.000Z',
        updatedAt: '2025-07-31T18:03:23.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf85d-3edaf85e-4edaf85f-8edaf860-3edaf8613edaf862',
        cusip: '67066G104',
        accountNumber: '670610222',
        email: 'daniel.gonzalez22@yopmail.com',
        firstName: 'Daniel',
        lastName: 'Gonzalez',
        fullName: 'Daniel Gonzalez',
        numberOfShares: 3294,
        totalShares: 3294,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '333 Hillcrest Way',
        addressLine2: null,
        city: 'Portland',
        state: 'OR',
        zipCode: '97201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:24.000Z',
        updatedAt: '2025-07-31T18:03:24.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf85e-3edaf85f-4edaf860-8edaf861-3edaf8623edaf863',
        cusip: '67066G104',
        accountNumber: '670610223',
        email: 'betty.nelson23@yopmail.com',
        firstName: 'Betty',
        lastName: 'Nelson',
        fullName: 'Betty Nelson',
        numberOfShares: 3421,
        totalShares: 3421,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '444 Valley Road',
        addressLine2: null,
        city: 'Las Vegas',
        state: 'NV',
        zipCode: '89101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:25.000Z',
        updatedAt: '2025-07-31T18:03:25.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf85f-3edaf860-4edaf861-8edaf862-3edaf8633edaf864',
        cusip: '67066G104',
        accountNumber: '670610224',
        email: 'matthew.carter24@yopmail.com',
        firstName: 'Matthew',
        lastName: 'Carter',
        fullName: 'Matthew Carter',
        numberOfShares: 3548,
        totalShares: 3548,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '555 Ridge Avenue',
        addressLine2: 'Unit 5',
        city: 'Baltimore',
        state: 'MD',
        zipCode: '21201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:26.000Z',
        updatedAt: '2025-07-31T18:03:26.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf860-3edaf861-4edaf862-8edaf863-3edaf8643edaf865',
        cusip: '67066G104',
        accountNumber: '670610225',
        email: 'margaret.mitchell25@yopmail.com',
        firstName: 'Margaret',
        lastName: 'Mitchell',
        fullName: 'Margaret Mitchell',
        numberOfShares: 3675,
        totalShares: 3675,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '666 Highland Drive',
        addressLine2: null,
        city: 'Milwaukee',
        state: 'WI',
        zipCode: '53201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:27.000Z',
        updatedAt: '2025-07-31T18:03:27.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf861-3edaf862-4edaf863-8edaf864-3edaf8653edaf866',
        cusip: '67066G104',
        accountNumber: '670610226',
        email: 'anthony.perez26@yopmail.com',
        firstName: 'Anthony',
        lastName: 'Perez',
        fullName: 'Anthony Perez',
        numberOfShares: 3802,
        totalShares: 3802,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '777 Brook Street',
        addressLine2: null,
        city: 'Albuquerque',
        state: 'NM',
        zipCode: '87101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:28.000Z',
        updatedAt: '2025-07-31T18:03:28.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf862-3edaf863-4edaf864-8edaf865-3edaf8663edaf867',
        cusip: '67066G104',
        accountNumber: '670610227',
        email: 'sandra.roberts27@yopmail.com',
        firstName: 'Sandra',
        lastName: 'Roberts',
        fullName: 'Sandra Roberts',
        numberOfShares: 3929,
        totalShares: 3929,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '888 Canyon Road',
        addressLine2: null,
        city: 'Tucson',
        state: 'AZ',
        zipCode: '85701',
        country: 'USA',
        createdAt: '2025-07-31T17:03:29.000Z',
        updatedAt: '2025-07-31T18:03:29.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf863-3edaf864-4edaf865-8edaf866-3edaf8673edaf868',
        cusip: '67066G104',
        accountNumber: '670610228',
        email: 'mark.turner28@yopmail.com',
        firstName: 'Mark',
        lastName: 'Turner',
        fullName: 'Mark Turner',
        numberOfShares: 4056,
        totalShares: 4056,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '999 Summit Avenue',
        addressLine2: null,
        city: 'Fresno',
        state: 'CA',
        zipCode: '93701',
        country: 'USA',
        createdAt: '2025-07-31T17:03:30.000Z',
        updatedAt: '2025-07-31T18:03:30.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf864-3edaf865-4edaf866-8edaf867-3edaf8683edaf869',
        cusip: '67066G104',
        accountNumber: '670610229',
        email: 'ashley.phillips29@yopmail.com',
        firstName: 'Ashley',
        lastName: 'Phillips',
        fullName: 'Ashley Phillips',
        numberOfShares: 4183,
        totalShares: 4183,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '1000 Plaza Drive',
        addressLine2: 'Suite 300',
        city: 'Sacramento',
        state: 'CA',
        zipCode: '95814',
        country: 'USA',
        createdAt: '2025-07-31T17:03:31.000Z',
        updatedAt: '2025-07-31T18:03:31.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf87a-3edaf87b-4edaf87c-8edaf87d-3edaf87e3edaf87f',
        cusip: '67066G104',
        accountNumber: '670610230',
        email: 'donald.campbell30@yopmail.com',
        firstName: 'Donald',
        lastName: 'Campbell',
        fullName: 'Donald Campbell',
        numberOfShares: 4310,
        totalShares: 4310,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '1100 Gateway Blvd',
        addressLine2: null,
        city: 'Kansas City',
        state: 'MO',
        zipCode: '64101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:32.000Z',
        updatedAt: '2025-07-31T18:03:32.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf87b-3edaf87c-4edaf87d-8edaf87e-3edaf87f3edaf880',
        cusip: '67066G104',
        accountNumber: '670610231',
        email: 'kimberly.parker31@yopmail.com',
        firstName: 'Kimberly',
        lastName: 'Parker',
        fullName: 'Kimberly Parker',
        numberOfShares: 4437,
        totalShares: 4437,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '1212 Central Avenue',
        addressLine2: null,
        city: 'Mesa',
        state: 'AZ',
        zipCode: '85201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:33.000Z',
        updatedAt: '2025-07-31T18:03:33.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf87c-3edaf87d-4edaf87e-8edaf87f-3edaf8803edaf881',
        cusip: '67066G104',
        accountNumber: '670610232',
        email: 'steven.evans32@yopmail.com',
        firstName: 'Steven',
        lastName: 'Evans',
        fullName: 'Steven Evans',
        numberOfShares: 4564,
        totalShares: 4564,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '1313 North Main Street',
        addressLine2: null,
        city: 'Virginia Beach',
        state: 'VA',
        zipCode: '23451',
        country: 'USA',
        createdAt: '2025-07-31T17:03:34.000Z',
        updatedAt: '2025-07-31T18:03:34.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf87d-3edaf87e-4edaf87f-8edaf880-3edaf8813edaf882',
        cusip: '67066G104',
        accountNumber: '670610233',
        email: 'donna.edwards33@yopmail.com',
        firstName: 'Donna',
        lastName: 'Edwards',
        fullName: 'Donna Edwards',
        numberOfShares: 4691,
        totalShares: 4691,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '1414 South Park Road',
        addressLine2: null,
        city: 'Omaha',
        state: 'NE',
        zipCode: '68101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:35.000Z',
        updatedAt: '2025-07-31T18:03:35.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf87e-3edaf87f-4edaf880-8edaf881-3edaf8823edaf883',
        cusip: '67066G104',
        accountNumber: '670610234',
        email: 'paul.collins34@yopmail.com',
        firstName: 'Paul',
        lastName: 'Collins',
        fullName: 'Paul Collins',
        numberOfShares: 4818,
        totalShares: 4818,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '1515 East Broadway',
        addressLine2: 'Apt 9',
        city: 'Oakland',
        state: 'CA',
        zipCode: '94601',
        country: 'USA',
        createdAt: '2025-07-31T17:03:36.000Z',
        updatedAt: '2025-07-31T18:03:36.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf87f-3edaf880-4edaf881-8edaf882-3edaf8833edaf884',
        cusip: '67066G104',
        accountNumber: '670610235',
        email: 'emily.stewart35@yopmail.com',
        firstName: 'Emily',
        lastName: 'Stewart',
        fullName: 'Emily Stewart',
        numberOfShares: 4945,
        totalShares: 4945,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '1616 West End Avenue',
        addressLine2: null,
        city: 'Miami',
        state: 'FL',
        zipCode: '33101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:37.000Z',
        updatedAt: '2025-07-31T18:03:37.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf880-3edaf881-4edaf882-8edaf883-3edaf8843edaf885',
        cusip: '67066G104',
        accountNumber: '670610236',
        email: 'andrew.sanchez36@yopmail.com',
        firstName: 'Andrew',
        lastName: 'Sanchez',
        fullName: 'Andrew Sanchez',
        numberOfShares: 5072,
        totalShares: 5072,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '1717 Riverside Drive',
        addressLine2: null,
        city: 'Minneapolis',
        state: 'MN',
        zipCode: '55401',
        country: 'USA',
        createdAt: '2025-07-31T17:03:38.000Z',
        updatedAt: '2025-07-31T18:03:38.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf881-3edaf882-4edaf883-8edaf884-3edaf8853edaf886',
        cusip: '67066G104',
        accountNumber: '670610237',
        email: 'michelle.morris37@yopmail.com',
        firstName: 'Michelle',
        lastName: 'Morris',
        fullName: 'Michelle Morris',
        numberOfShares: 5199,
        totalShares: 5199,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '1818 Mountain View Lane',
        addressLine2: null,
        city: 'Tulsa',
        state: 'OK',
        zipCode: '74101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:39.000Z',
        updatedAt: '2025-07-31T18:03:39.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf882-3edaf883-4edaf884-8edaf885-3edaf8863edaf887',
        cusip: '67066G104',
        accountNumber: '670610238',
        email: 'joshua.rogers38@yopmail.com',
        firstName: 'Joshua',
        lastName: 'Rogers',
        fullName: 'Joshua Rogers',
        numberOfShares: 5326,
        totalShares: 5326,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '1919 Harbor Way',
        addressLine2: null,
        city: 'Cleveland',
        state: 'OH',
        zipCode: '44101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:40.000Z',
        updatedAt: '2025-07-31T18:03:40.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf883-3edaf884-4edaf885-8edaf886-3edaf8873edaf888',
        cusip: '67066G104',
        accountNumber: '670610239',
        email: 'dorothy.reed39@yopmail.com',
        firstName: 'Dorothy',
        lastName: 'Reed',
        fullName: 'Dorothy Reed',
        numberOfShares: 5453,
        totalShares: 5453,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '2020 Bridge Street',
        addressLine2: null,
        city: 'Wichita',
        state: 'KS',
        zipCode: '67201',
        country: 'USA',
        createdAt: '2025-07-31T17:03:41.000Z',
        updatedAt: '2025-07-31T18:03:41.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf899-3edaf89a-4edaf89b-8edaf89c-3edaf89d3edaf89e',
        cusip: '67066G104',
        accountNumber: '670610240',
        email: 'kenneth.cook40@yopmail.com',
        firstName: 'Kenneth',
        lastName: 'Cook',
        fullName: 'Kenneth Cook',
        numberOfShares: 580,
        totalShares: 580,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL001',
        addressLine1: '2121 Harbor Drive',
        addressLine2: 'Unit 15',
        city: 'Arlington',
        state: 'TX',
        zipCode: '76001',
        country: 'USA',
        createdAt: '2025-07-31T17:03:42.000Z',
        updatedAt: '2025-07-31T18:03:42.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf89a-3edaf89b-4edaf89c-8edaf89d-3edaf89e3edaf89f',
        cusip: '67066G104',
        accountNumber: '670610241',
        email: 'carol.morgan41@yopmail.com',
        firstName: 'Carol',
        lastName: 'Morgan',
        fullName: 'Carol Morgan',
        numberOfShares: 707,
        totalShares: 707,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL002',
        addressLine1: '2222 Bay Street',
        addressLine2: null,
        city: 'New Orleans',
        state: 'LA',
        zipCode: '70112',
        country: 'USA',
        createdAt: '2025-07-31T17:03:43.000Z',
        updatedAt: '2025-07-31T18:03:43.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf89b-3edaf89c-4edaf89d-8edaf89e-3edaf89f3edaf8a0',
        cusip: '67066G104',
        accountNumber: '670610242',
        email: 'kevin.bell42@yopmail.com',
        firstName: 'Kevin',
        lastName: 'Bell',
        fullName: 'Kevin Bell',
        numberOfShares: 834,
        totalShares: 834,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL003',
        addressLine1: '2323 Coast Highway',
        addressLine2: null,
        city: 'Tampa',
        state: 'FL',
        zipCode: '33601',
        country: 'USA',
        createdAt: '2025-07-31T17:03:44.000Z',
        updatedAt: '2025-07-31T18:03:44.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf89c-3edaf89d-4edaf89e-8edaf89f-3edaf8a03edaf8a1',
        cusip: '67066G104',
        accountNumber: '670610243',
        email: 'amanda.murphy43@yopmail.com',
        firstName: 'Amanda',
        lastName: 'Murphy',
        fullName: 'Amanda Murphy',
        numberOfShares: 961,
        totalShares: 961,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL004',
        addressLine1: '2424 Island Avenue',
        addressLine2: null,
        city: 'Honolulu',
        state: 'HI',
        zipCode: '96801',
        country: 'USA',
        createdAt: '2025-07-31T17:03:45.000Z',
        updatedAt: '2025-07-31T18:03:45.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf89d-3edaf89e-4edaf89f-8edaf8a0-3edaf8a13edaf8a2',
        cusip: '67066G104',
        accountNumber: '670610244',
        email: 'brian.bailey44@yopmail.com',
        firstName: 'Brian',
        lastName: 'Bailey',
        fullName: 'Brian Bailey',
        numberOfShares: 1088,
        totalShares: 1088,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL005',
        addressLine1: '2525 Prairie Road',
        addressLine2: null,
        city: 'Aurora',
        state: 'CO',
        zipCode: '80010',
        country: 'USA',
        createdAt: '2025-07-31T17:03:46.000Z',
        updatedAt: '2025-07-31T18:03:46.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf89e-3edaf89f-4edaf8a0-8edaf8a1-3edaf8a23edaf8a3',
        cusip: '67066G104',
        accountNumber: '670610245',
        email: 'melissa.rivera45@yopmail.com',
        firstName: 'Melissa',
        lastName: 'Rivera',
        fullName: 'Melissa Rivera',
        numberOfShares: 1215,
        totalShares: 1215,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL006',
        addressLine1: '2626 Desert Lane',
        addressLine2: null,
        city: 'Anaheim',
        state: 'CA',
        zipCode: '92801',
        country: 'USA',
        createdAt: '2025-07-31T17:03:47.000Z',
        updatedAt: '2025-07-31T18:03:47.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf89f-3edaf8a0-4edaf8a1-8edaf8a2-3edaf8a33edaf8a4',
        cusip: '67066G104',
        accountNumber: '670610246',
        email: 'george.cooper46@yopmail.com',
        firstName: 'George',
        lastName: 'Cooper',
        fullName: 'George Cooper',
        numberOfShares: 1342,
        totalShares: 1342,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL007',
        addressLine1: '2727 Garden Street',
        addressLine2: null,
        city: 'Santa Ana',
        state: 'CA',
        zipCode: '92701',
        country: 'USA',
        createdAt: '2025-07-31T17:03:48.000Z',
        updatedAt: '2025-07-31T18:03:48.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf8a0-3edaf8a1-4edaf8a2-8edaf8a3-3edaf8a43edaf8a5',
        cusip: '67066G104',
        accountNumber: '670610247',
        email: 'deborah.richardson47@yopmail.com',
        firstName: 'Deborah',
        lastName: 'Richardson',
        fullName: 'Deborah Richardson',
        numberOfShares: 1469,
        totalShares: 1469,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL008',
        addressLine1: '2828 Vineyard Way',
        addressLine2: null,
        city: 'St. Louis',
        state: 'MO',
        zipCode: '63101',
        country: 'USA',
        createdAt: '2025-07-31T17:03:49.000Z',
        updatedAt: '2025-07-31T18:03:49.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf8a1-3edaf8a2-4edaf8a3-8edaf8a4-3edaf8a53edaf8a6',
        cusip: '67066G104',
        accountNumber: '670610248',
        email: 'edward.cox48@yopmail.com',
        firstName: 'Edward',
        lastName: 'Cox',
        fullName: 'Edward Cox',
        numberOfShares: 1596,
        totalShares: 1596,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL009',
        addressLine1: '2929 Orchard Drive',
        addressLine2: null,
        city: 'Riverside',
        state: 'CA',
        zipCode: '92501',
        country: 'USA',
        createdAt: '2025-07-31T17:03:50.000Z',
        updatedAt: '2025-07-31T18:03:50.000Z',
        brokerId: 'BROKER002',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
    {
        id: '3edaf8a2-3edaf8a3-4edaf8a4-8edaf8a5-3edaf8a63edaf8a7',
        cusip: '67066G104',
        accountNumber: '670610249',
        email: 'stephanie.howard49@yopmail.com',
        firstName: 'Stephanie',
        lastName: 'Howard',
        fullName: 'Stephanie Howard',
        numberOfShares: 1723,
        totalShares: 1723,
        recordDate: '2025-07-15T00:00:00.000Z',
        mapAccountAcknowledgement: false,
        naaPreference: null,
        noboObo: null,
        preferredVoting: null,
        managerCode: null,
        repCode: null,
        legalProxyRequested: false,
        controlNo: 'CTRL010',
        addressLine1: '3030 Meadowbrook Lane',
        addressLine2: null,
        city: 'Corpus Christi',
        state: 'TX',
        zipCode: '78401',
        country: 'USA',
        createdAt: '2025-07-31T17:03:51.000Z',
        updatedAt: '2025-07-31T18:03:51.000Z',
        brokerId: 'BROKER001',
        cusipData: { cusip: '67066G104', description: '', createdAt: '2025-07-15T10:00:00.000Z', updatedAt: '2025-07-15T10:00:00.000Z' },
    },
];
